/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  CashBalanceLatestResponseResponse,
  FailureResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns current cash balance declaration of all accounting locations
 * @summary Latest cash declaration for accounting locations in a branch
 */
export const getLatestCashDeclarations = (signal?: AbortSignal) => {
  return customInstance<CashBalanceLatestResponseResponse>({
    url: `/BboCashManagementService/v1/cash-declaration/accounting-location`,
    method: 'get',
    signal,
  });
};

export const getGetLatestCashDeclarationsQueryKey = () => {
  return [`/BboCashManagementService/v1/cash-declaration/accounting-location`] as const;
};

export const getGetLatestCashDeclarationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclarations>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclarations>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestCashDeclarationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestCashDeclarations>>> = ({
    signal,
  }) => getLatestCashDeclarations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestCashDeclarations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestCashDeclarationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestCashDeclarations>>
>;
export type GetLatestCashDeclarationsQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Latest cash declaration for accounting locations in a branch
 */
export const useGetLatestCashDeclarations = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclarations>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclarations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLatestCashDeclarationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
